/** @jsxImportSource @emotion/react */
import { SerializedStyles } from "@emotion/react";
import { CSSProperties } from "react";
import { icons } from "../../theme/icons";
import { theme } from "../../theme/theme";
import Box from "../Box/Box";
import Typography from "../Typography/Typography";
import useBreakpoint from "../../hooks/useBreakpoint";

type ButtonProps = {
  onClick: () => void;
  label: string;
  type: "play" | "discover" | "back" | "close" | "zoomIn" | "backIcon";
  style?: CSSProperties | SerializedStyles;
};

const { PlayIcon, DiscoverIcon, CloseIcon, ZoomInIcon, BackIcon } =
  icons.general;

const Button = ({ onClick, label, type, style }: ButtonProps) => {

  const {isMobile} = useBreakpoint();
  return (
    <Box
      style={{
        ...style,
      }}
      onClick={onClick}
      backgroundColor={theme.colors.highlight}
      minWidth={
        isMobile && type === "backIcon"? 32:
        type === "close" || type === "zoomIn" || type === "backIcon" ? 52 : 150
      }
      height={
        isMobile && type === "backIcon"? 32:
        type === "close" || type === "zoomIn" || type === "backIcon" ? 52 : 40
      }
      hoverStyle={{ cursor: "pointer" }}
      display="flex"
      justifyContent="center"
      alignItems="center"
      marginTop={0}
    >
      {type === "discover" ? (
        <DiscoverIcon />
      ) : type === "play" ? (
        <PlayIcon />
      ) : type === "back" ? (
        "back"
      ) : type === "close" ? (
        <CloseIcon />
      ) : type === "zoomIn" ? (
        <ZoomInIcon />
      ) : type === "backIcon" ? (
        <BackIcon css={{
          width: isMobile ? 16: undefined
        }} />
      ) : undefined}
      {!!label && (
        <Typography variant={isMobile ? "body1_mobile": "body1"} style={{ fontWeight: 700, marginLeft: 16 }}>
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default Button;
